export default __webpack_public_path__ + "static/media/logowhite.21dfd06d.png";